import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export const MonthlyBarChart = ({ data,isAttendance }: any) => {
  const attendanceDataKeys = [
    "Noida",
    "Delhi",
    "Kolkata",
    "Hyderabad",
    "Mumbai",
    "Bangalore",
    "Coimbatore",
    "Ahmedabad",
    "Baroda",
    "Madurai",
    "Vijayawada",
    "Indore",
    "Lucknow",
  ];

  const barDataKeys = isAttendance
    ? attendanceDataKeys
    : [
        "Noida",
        "Delhi",
        "Kolkata",
        "Hyderabad",
        "Mumbai",
        "Bangalore",
        "Coimbatore",
        "Ahmedabad",
        "Baroda",
        "Madurai",
        "Vijayawada",
        "Indore",
        "Lucknow",
      ];

  const colors = [
    "#FF5733",
    "#4287f5",
    "#FFC300",
    "#8E44AD",
    "#FF6F61",
    "#2ECC71",
    "#3498DB",
    "#E74C3C",
    "#F39C12",
    "#1ABC9C",
    "#D35400",
    "#E74C3C",
    "#34495E",
  ];

  return (
    <BarChart
      width={700}
      height={350}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      {/* <CartesianGrid strokeDasharray="3 3" /> */}
      <XAxis
        dataKey="date"
        angle={-45}
        interval={0}
        tick={<CustomTick />}
        height={65}
        dy={25}
        dx={-25}
      />
       <YAxis
        tickFormatter={(value) => (Number.isInteger(value) ? value : "")}
      />
      <Tooltip />
      {<Legend
      wrapperStyle={{
        paddingTop: 20,
      }}
      />}
     {barDataKeys.map((key, index) => (
        <Bar key={key} dataKey={key} stackId="a" fill={colors[index]} />
      ))}
    </BarChart>
  );
};

const CustomTick = (props: any) => {
  const { x, y, payload } = props;
  const day = payload.value.split(" ")[1].replace("(", "").replace(")", "");

  const isHighlightedDay = day === "Mon" || day === "Wed" || day === "Fri";

  return (
    <text
      x={x}
      y={y + 15}
      fill={isHighlightedDay ? "#FF0000" : "#666"} 
      fontWeight={isHighlightedDay ? "bold" : "normal"}
      textAnchor="middle"
      transform={`rotate(-45, ${x+ 10}, ${y+ 45})`}
      fontSize={12}
    >
      {payload.value}
    </text>
  );
};

